var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',_vm._g(_vm._b({class:_vm.baseClass,attrs:{"variant":_vm.variant,"size":_vm.size}},'b-btn',_vm.$attrs,false),_vm.$listeners),[_c('i',{class:("fa fa-" + _vm.icon)})])}
var staticRenderFns = []

export { render, staticRenderFns }